function asObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value)
        ? value
        : undefined;
}
function boundedPixel(value, minimum, maximum) {
    return typeof value === 'number' && Number.isInteger(value) && value >= minimum && value <= maximum
        ? value
        : undefined;
}
function normalizeViewport(value) {
    const viewport = asObject(value);
    if (!viewport)
        return undefined;
    const result = {
        widthPx: boundedPixel(viewport.widthPx, 16, 512),
        heightPx: boundedPixel(viewport.heightPx, 16, 512),
        rightPx: boundedPixel(viewport.rightPx, 0, 256),
        bottomPx: boundedPixel(viewport.bottomPx, 0, 256),
    };
    return Object.values(result).some(value => value !== undefined) ? result : undefined;
}
export function normalizeLauncherOptions(value) {
    const options = asObject(value);
    if (!options)
        return undefined;
    const renderMode = options.renderMode === 'image' ? 'image' : 'framed';
    const desktop = normalizeViewport(options.desktop);
    const mobile = normalizeViewport(options.mobile);
    return renderMode === 'image' || desktop || mobile ? { renderMode, desktop, mobile } : undefined;
}
